<template>
  <div class="hubspot-modal">
    <div class="overlay" @click="$emit('close')"></div>
    <div class="form-wrapper">
      <div v-show="!formSucceeded" class="close" :class="{ show: ready }" @click="$emit('close')">
        <span>
          <i class="fa-light fa-times"></i>
        </span>
      </div>
      <div v-show="formSucceeded" class="continue">
        <button class="btn btn-secondary" @click="$emit('close')">Continue</button>
      </div>
      <HubSpotForm class="hubspot" @form-succeeded="formDidSend" />
    </div>
  </div>
</template>

<script>
import HubSpotForm from "@/components/HubSpotForm";
export default {
  components: {
    HubSpotForm
  },
  data() {
    return {
      ready: false,
      formSucceeded: false
    };
  },
  methods: {
    formDidSend(){
      this.$nextTick(() => {this.formSucceeded = true})

      // document.querySelector(".book-summary").getBoundingClientRect
      // document.querySelector(".book-summary").clientHeight
    }
  },
  mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 2000);
  }
};
</script>

<style lang="less">
.hubspot-modal {
  position: absolute;
  z-index: 99;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  .form-wrapper {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .close {
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(calc((850px / 2) - 28px));
    z-index: 999;
    transition: 0.6s;
    opacity: 0;
  }
  .show {
    opacity: 1;
    transition: 0.6s;
  }

  .overlay {
    position: absolute;
    top: -100px;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.265);
  }

  .hubspot {
    width: 100%;
  }
  .continue {
    // position: relative;
    display: flex;
    justify-content: center;
    button {
      position: absolute;
      bottom: 5vw;
    }
  }
}
</style>
